export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10129.a8bd7b97.jpg";